<template>
  <div class="mobile-options">
    <div
      class="mobile-options__item"
      :class="{active: !enableMobileOptions}"
      @click="setEnableMobileOptions(false)"
    >
      <img
        src="https://sirvwebsite.sirv.com/assets/desktop.svg"
        alt="Desktop"
      >
    </div>
    <div
      class="mobile-options__item"
      :class="{active: enableMobileOptions}"
      @click="setEnableMobileOptions(true)"
    >
      <img
        src="https://sirvwebsite.sirv.com/assets/mobile.svg"
        alt="Mobile"
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'MobileOptionsControl',
  computed: {
    ...mapState(['enableMobileOptions'])
  },
  methods: {
    setEnableMobileOptions(value) {
      this.$store.dispatch('setEnableMobileOptions', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-options {
  display: flex;
  align-items: center;
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    cursor: pointer;
    position: relative;
    img {
      width: 20px;
      max-width: 100%;
      height: 20px;
    }
    &::after{
      transition: background-color .5s ease;
    }
    &.active {
      &::after{
        content: '';
        bottom: -5px;
        position: absolute;
        display: block;
        width: 100%;
        height: 2px;
        opacity: .8;
        background-color: #327bba;
      }
    }
  }
}
</style>
